import React, { useContext, useEffect, useState } from 'react';
import './Slide.scss';
import { FileContext } from 'context/FileContext';

function Slide(): JSX.Element {
  const { files, urls } = useContext(FileContext);
  const [ activeImg, setActiveImg ] = useState({ url: urls[0], file: files[0], index: 0 });

  const intervalId = setInterval(() => {
    const nextImg = {
      url: urls[0],
      file: files[0],
      index: 0,
    };

    if (activeImg.index < files.length - 1) {
      nextImg.url = urls[activeImg.index + 1];
      nextImg.file = files[activeImg.index + 1];
      nextImg.index = activeImg.index + 1;
    }
    setActiveImg(nextImg);
  }, 7000);

  useEffect(() => () => clearInterval(intervalId));

  return (
    <>
      {urls.map((url) => (
        <img className={`slide-item ${activeImg.url === url ? 'active' : ''}`} src={url} alt="img" />
      ))}
    </>
  );
}

export default Slide;
